import {
  collection,
  doc,
  getFirestore,
  serverTimestamp,
  setDoc,
} from 'firebase/firestore';

export default async function saveTestStandLog({ activeTestLogId, payload, isNew }) {
  const db = getFirestore();
  const ref = activeTestLogId
    ? doc(db, 'test_stand_logs', activeTestLogId)
    : doc(collection(db, 'test_stand_logs'));

  const docPayload = { ...payload, updatedAt: serverTimestamp() };

  if (isNew) {
    docPayload.createdAt = serverTimestamp();
    docPayload.startedAt = serverTimestamp();
  }

  await setDoc(ref, docPayload, { merge: true });
  return ref.id;
}
